import { useDocumentTitle } from "@/lib/use-document-title";
import { CustomerLayout } from "@/components/CustomerLayout";
import { usePartners } from "@/lib/data-hooks";
import { EmptyState, CardSkeletonGrid } from "@/components/EmptyState";
import { Tag } from "lucide-react";

function ErbjudandenPage() {
  useDocumentTitle("Erbjudanden & partners — Lagamobilen Access");
  const { data: partners = [], isLoading } = usePartners({ onlyActive: true });

  return (
    <CustomerLayout title="Partnererbjudanden">
      <p className="text-muted-foreground mb-10 max-w-2xl">Som Access-medlem får du exklusiva rabatter hos våra utvalda samarbetspartners. Visa ditt digitala medlemskort i butik eller online för att lösa in erbjudandet.</p>

      {isLoading && <CardSkeletonGrid count={4} className="grid md:grid-cols-2 gap-x-5 gap-y-12 max-w-5xl pt-6" />}
      {!isLoading && !partners.length && (
        <EmptyState
          icon={Tag}
          title="Inga partnererbjudanden just nu"
          description="Nya samarbetspartners läggs upp löpande. Kom tillbaka snart!"
          ctaLabel="Se dina förmåner"
          ctaTo="/access/formaner"
        />
      )}

      <div className="grid md:grid-cols-2 gap-x-5 gap-y-12 max-w-5xl pt-6">
        {partners.map(p => (
          <div key={p.id} className="relative">
            {p.discount_label && (
              <div className="absolute -top-6 -right-3 md:-right-5 z-10 w-24 h-24 rounded-full bg-[var(--color-gold)] text-black shadow-xl ring-4 ring-white flex items-center justify-center font-display font-extrabold text-base text-center px-2 leading-tight rotate-[8deg]">
                {p.discount_label}
              </div>
            )}
            <div className="card-soft p-6 pr-24 h-full hover:shadow-lg transition">
              <div className="text-[10px] font-display font-bold tracking-widest uppercase text-[var(--color-gold)] mb-1.5">Partnererbjudande</div>
              <div className="font-display font-bold text-lg">{p.name}</div>
              <p className="text-sm text-muted-foreground mt-1.5">{p.description}</p>
              {p.cta_url && <a href={p.cta_url} target="_blank" rel="noreferrer" className="mt-4 inline-block text-sm font-display font-semibold text-primary hover:underline">{p.cta_label || "Lös in erbjudande"} →</a>}
            </div>
          </div>
        ))}
      </div>
    </CustomerLayout>
  );
}

export default ErbjudandenPage;
